module.exports = __webpack_public_path__ + "img/48740351008220.36cd74bf.png";